import { Transaction } from 'prosemirror-state';
import { Decoration, DecorationSet } from 'prosemirror-view';

/**
 * Returns an updated decoration set based on the given parameters.
 * @param options - The options object.
 * @param {Decoration[]} options.add - The decorations to add.
 * @param {Decoration[]} options.remove - The decorations to remove.
 * @param {DecorationSet} options.decorationSet - The current decoration set.
 * @param {Transaction} options.tr - The current transaction.
 * @returns {DecorationSet} The updated decoration set.
 */

export function getUpdatedDecorations({
  add,
  remove,
  decorationSet,
  tr,
}: {
  add: Decoration[];
  remove: Decoration[];
  decorationSet: DecorationSet;
  tr: Transaction;
}) {
  if (remove.length) {
    decorationSet = decorationSet.remove(remove);
  }

  if (add.length) {
    decorationSet = decorationSet.add(tr.doc, add);
  }
  return decorationSet;
}
